export default __webpack_public_path__ + "static/media/CNo.86-6.c1da3c13.jpg";